export var easeInOut = 'cubic-bezier(0.15,1,0.3,1)';
export var easeOut = 'cubic-bezier(0.2,0,0,1)';
export var easeIn = 'cubic-bezier(0.8,0,0,0.8)';
export var easeIn40Out = 'cubic-bezier(0.4,0,0,1)';
export var easeIn60Out = 'cubic-bezier(0.6,0,0,1)';
export var easeIn80Out = 'cubic-bezier(0.8,0,0,1)';
export var linear = 'cubic-bezier(0,0,1,1)';